module.exports = __webpack_public_path__ + "static/media/bronchitis.f29a310f.svg";